import React from 'react';
import { useProjectState, setProjectState } from '@starflow/app/store';
import { Slider } from '@mantine/core';
import IncreaseIcon from './IncreaseIcon';
import DecreaseIcon from './DecreaseIcon';
import sliderclasses from './slider.module.scss';

const step = 0.1;
const min = 0.5;
const max = 1;

const ZoomBar = () => {
  const flowScale = useProjectState('flowScale');

  const decline = () => {
    const scale = Math.max(min, (flowScale * 10 - step * 10) / 10);
    setProjectState({ flowScale: scale });
  };
  const increase = () => {
    const scale = Math.min(max, (flowScale * 10 + step * 10) / 10);
    setProjectState({ flowScale: scale });
  };
  const scaleFlow = (scale) => {
    setProjectState({ flowScale: scale });
  };

  return (
    <div className="flex justify-center items-center h-full ml-[20px]">
      <div className={flowScale !== min && 'cursor-pointer'} onClick={() => decline()}>
        <DecreaseIcon currentColor={flowScale === min ? '#D7D7D7' : '#2D2D2D'} />
      </div>
      <Slider
        min={min}
        max={max}
        step={step}
        value={flowScale}
        onChange={(scale) => scaleFlow(scale)}
        size={4}
        className="w-[88px] mx-[8px]"
        classNames={sliderclasses}
      />
      <div className={flowScale !== max && 'cursor-pointer'} onClick={() => increase()}>
        <IncreaseIcon currentColor={flowScale === max ? '#D7D7D7' : '#2D2D2D'} />
      </div>
    </div>
  );
};

export default ZoomBar;
